module.exports = __webpack_public_path__ + "731f654280e4f3e3755b145a1f9a346b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/UZ.svg
// module id = r37R
// module chunks = 0